import { type PreferenzeUtenteRequest } from '@framework/api-client/api/users/schemas/preferenzeUtenteRequest.ts';
import { yup } from '@framework/validation/initYup.ts';

/**
 * Preferenze dei canali per le comunicazioni di cortesia dell'utente
 * frontoffice: l'indirizzo e-mail è obbligatorio e validato solo quando
 * il canale e-mail è attivo.
 */
export const UserCommunicationPreferencesSchema: yup.ObjectSchema<PreferenzeUtenteRequest> =
  yup
    .object({
      flNotificaEmail: yup
        .boolean()
        .default(false)
        .label('Notifica via e-mail'),
      notificaEmail: yup
        .string()
        .email()
        .nullable()
        .when('flNotificaEmail', ([flNotificaEmail], schema) =>
          flNotificaEmail ? schema.required() : schema.strip(),
        )
        .label('Indirizzo e-mail'),
      flNotificaEsterna: yup
        .boolean()
        .default(false)
        .label('Notifica su App IO'),
      emailValida: yup.boolean().notRequired().strip(),
    })
    .noUnknown();

export type UserCommunicationPreferences = yup.InferType<
  typeof UserCommunicationPreferencesSchema
>;
